/** Date first; legacy timeline text is an opaque fallback, never rewritten. */
export function clientMoveIn(client: { move_in_date?: string | null; move_in_timeline?: string | null }): string | undefined {
  return client.move_in_date ?? client.move_in_timeline ?? undefined;
}
